import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/list-checks.vue
var o = {
	name: "DtIconListChecks",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--list-checks"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "List Checks",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M4.5 3a.5.5 0 0 1 .5-.5h5.5a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5Zm0 3a.5.5 0 0 1 .5-.5h5.5a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5Zm0 3a.5.5 0 0 1 .5-.5h5.5a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5ZM2.646 2.146a.5.5 0 1 1 .708.708l-1 1a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 2.793l.646-.647Zm0 3a.5.5 0 1 1 .708.708l-1 1a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 5.793l.646-.647Zm0 3a.5.5 0 1 1 .708.708l-1 1a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 8.793l.646-.647Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=list-checks.js.map